import PropTypes from 'prop-types';
import { ComponentLoader } from '../../global/ComponentLoader/ComponentLoader';

const importFunc = () => {
    return import(
        /* webpackChunkName: "PdpRespZoomModalWrapper" */
        './PdpRespZoomModalWrapper'
    ).then(PdpRespZoomModal => PdpRespZoomModal.PdpRespZoomModalWrapper);
};

export function PdpRespZoomModalLoader(props) {
    return <ComponentLoader {...props} load={props.isOpen} importFunc={importFunc} />;
}

PdpRespZoomModalLoader.propTypes = {
    isOpen: PropTypes.bool.isRequired,
};
